export function getThemes() {
    let themesObj = {...THEMES}
    let themes = []
    const themeKeys = Object.keys(THEMES)

    for( let i = 0; i < themeKeys.length; i++ ){
        const thisTheme = themesObj[themeKeys[i]]
        const isDevelopment = ( !thisTheme.type ) ? false : true
        
        let obj = {
            name: themeKeys[i],
            ...thisTheme
        }
        
        if ( isDevelopment ) delete themesObj[themeKeys[i]] 
        else themes.push(obj)
    }

    const currentTheme = themes.find( t => t.store == window.theme.permanentDomain )
    // FOR DEBUGGING THE GEO-POPUP
    // const currentTheme = Object.entries(THEMES).find( t => t[1].store == window.theme.permanentDomain )[1]

    return {
        themes,
        current: currentTheme
    }
}